import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import PublicUserPage from 'buyside/components/presentation/PublicUserPage/publicUserPage';

const PublicUserPageRoot: FC<{ anonymous: string; userId: string }> = ({ anonymous, userId }) => {
  if (!userId) return;

  return (
    <Router basename={`/pro/user/${encodeURI(userId)}/public`}>
      <ErrorBoundary pageName="the public user page">
        <PublicUserPage anonymous={anonymous === 'true'} userId={userId} />
      </ErrorBoundary>
    </Router>
  );
};

export default PublicUserPageRoot;
